import { request } from './request'

export async function validateAuthToken(): Promise<any> {
	const response = await request({ url: '/auth/token/validate', method: 'GET' })
	return response
}